import { ShieldLockRegular } from '@fluentui/react-icons'
import { Button } from '@fluentui/react-components'
import banner from '@/assets/brand/banner-minister.jpeg'
import { MinistryBrand } from '@/components/layout/MinistryBrand'
import { LoadingState } from '@/components/common/LoadingState'
import { ErrorState } from '@/components/common/ErrorState'
import type { AuthFlowStatus } from '@/hooks/useAuthFlow'
import styles from './LoginScreen.module.css'

interface LoginScreenProps {
  status: AuthFlowStatus
  errorMessage: string | null
  onSignIn: () => void
}

export function LoginScreen({ status, errorMessage, onSignIn }: LoginScreenProps) {
  const isBusy = status === 'authenticating' || status === 'initializing'

  return (
    <div className={styles.root}>
      <div className={styles.banner} style={{ backgroundImage: `url(${banner})` }} role="presentation" />
      <div className={styles.panel}>
        <div className={styles.card}>
          <MinistryBrand variant="lockup" className={styles.logo} />

          <div className={styles.productBlock}>
            <span className={styles.productEyebrow}>SOC-Copilot</span>
            <h1 className={styles.title}>Acces SOC-Copilot</h1>
            <p className={styles.subtitle}>
              Autentifică-te cu identitatea organizației pentru a continua.
            </p>
          </div>

          {status === 'initializing' ? (
            <LoadingState label="Se inițializează…" />
          ) : (
            <>
              <Button
                appearance="primary"
                size="large"
                className={styles.signInButton}
                onClick={onSignIn}
                disabled={isBusy}
              >
                {status === 'authenticating' ? 'Se autentifică…' : 'Autentificare cu Microsoft'}
              </Button>

              {errorMessage && (
                <ErrorState
                  title="Autentificarea a eșuat"
                  detail={errorMessage}
                  onRetry={onSignIn}
                  retryLabel="Încearcă din nou"
                />
              )}
            </>
          )}

          <div className={styles.modeNotice}>
            <ShieldLockRegular aria-hidden="true" />
            <span>Read-only investigation • Human-controlled response</span>
          </div>
        </div>
      </div>
    </div>
  )
}
